const VALUES = [
    {display:'Zero', value:'ZR'},
    {display:'Fixed, Non-Zero', value:'FNZR'},
    {display:'Fixed to Float, Fixed', value:'F2FF'},
    {display:'Floating', value:'FLT'},
    {display:'Multi-Step', value:'MULTI-STEP'}
]

export const COUPON_FEATURES = VALUES
    .map(({value, display}) => {
        return {
            label: display,
            display,
            value: 'holdCouponTypeCode=' + value
        }
    })

export const COUPON_FEATURE_LABELS = Object.fromEntries(VALUES.map(a=> [a.value,a.display]))

export const COUPON_TYPE_LABELS = {
    "1": "Adj Rate",
    "2": "Stripped Conv",
    "3": "Deferred Int",
    "4": "Floating Rate at Floor",
    "5": "Floating Rate",
    "6": "Inv Floating",
    "7": "Linked Inv Floater",
    "8": "Flexible Rate",
    "9": "O.I.D.",
    "A": "Regular",
    "B": "Zero Coupon",
    "C": "Payment-in-Kind",
    "D": "Stepped: Known Future Coupon Rates",
    "E": "Variable or Floating",
    "F": "Interest-at-Maturity",
    "G": "Stepped Payment-in-Kind",
    "H": "Variable Payment-in-Kind",
    "I": "Stepped Interest-at-Maturity",
    "J": "Variable Interest-at-Maturity",
    "K": "Credit Sensitive",
    "L": "Credit Sensitive Variable or Reset",
    "M": "Short-term Discount Interest",
    "N": "Fixed rate of interest",
    "O": "Stripped Coupon Pay",
    "S": "Stripped Coupon",
    "T": "Floating Auction Rate",
    "X": "Stripped Prin",
    "Y": "Reserve CUSIP",
    "Z": "Other situation"
}


export const COUPON_DAY_COUNT_LABELS = {
    "1": "30/360",
    "2": "Actual",
    "3": "Actual/360",
    "5": "Actual/365",
    "6": "30E/360",
    "8": "Changeable",
    "9": "Not available"
}